export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const API_KEY = '93ca22a5-b875-49f2-9756-5f88cb63bf6c';

export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;

export const MODAL_CLOSE_SEC = 2.5;
